var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSmallTitle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 104,
    viewBox: "0 0 153 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip0_1652_3353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.0836 9.0087C82.5466 9.0491 86.7216 -2.0875 73.2838 0.336423C37.7899 6.7733 12.6998 30.4874 7.42408 37.2744C2.13489 44.0614 -14.0414 72.381 28.7151 69.0683C71.4716 65.7556 95.0984 41.1392 98.3873 36.6146C111.208 18.8929 106.187 7.15036 83.0836 9.0087ZM74.3309 3.21821C74.3309 3.21821 82.7211 1.27906 79.2845 9.61468C79.2845 9.61468 58.3694 11.6077 29.2118 28.9388C29.2118 28.9388 44.3947 7.79674 74.3309 3.21821ZM63.2022 57.797C42.9314 65.3785 23.6675 63.9645 20.1906 54.6055C16.7137 45.2599 30.326 31.5243 50.6101 23.9293C70.8943 16.3344 90.1448 17.7618 93.6217 27.1208C97.0986 36.4664 83.4863 50.202 63.2022 57.797Z",
    fill: "#CBD3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.395 82.5755L114.375 31.4575H127.625L126.659 36.9114C128.901 34.6087 130.86 33.0466 132.539 32.2386C134.794 31.1478 137.183 30.5957 139.694 30.5957C144.647 30.5957 148.138 32.4944 150.165 36.2785C152.205 40.076 152.729 44.7622 151.749 50.3507C150.661 56.5183 148.366 61.218 144.849 64.4634C141.331 67.7087 137.318 69.3382 132.82 69.3382C130.632 69.3382 128.713 68.9611 127.048 68.2205C125.383 67.4798 123.96 66.3621 122.806 64.8808L119.691 82.5755H105.395ZM125.303 50.041C124.793 52.9632 125.021 55.1312 126.001 56.5452C126.981 57.9592 128.417 58.6729 130.297 58.6729C131.948 58.6729 133.438 57.9996 134.794 56.6395C136.15 55.2794 137.116 52.9766 137.68 49.7313C138.204 46.7283 138.002 44.5333 137.103 43.1328C136.19 41.7323 134.901 41.0321 133.223 41.0321C131.411 41.0321 129.787 41.7458 128.323 43.1597C126.873 44.5737 125.853 46.8764 125.303 50.0545V50.041Z",
    fill: "#CBD3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8862 31.4443H63.4851L65.3645 54.4178L76.8423 31.4443H89.4611L93.1528 54.6063L103.141 31.4443H116.659L96.67 68.2342H84.1585L80.6145 46.0956L69.5394 68.2342H56.9877L49.8594 31.4443H49.8862Z",
    fill: "#CBD3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0176 89.201H65.5064V91.396H74.0711V93.7795H64.6875V96.0149H69.8156V97.2134H65.5467V99.4488H74.1114V102.034H76.0579V97.2134H71.7621V96.0149H76.8902V93.7795H76.0176V89.1875V89.201Z",
    fill: "#CBD3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.054 89.2012H101.107V90.3054H95.2004V89.2012H93.2539V96.3518H103.054V89.2012ZM101.107 92.6889V93.9548H95.2004V92.6889H101.107Z",
    fill: "#CBD3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0352 97.0654V99.3951H97.1632V101.873H99.1098V99.3951H104.238V97.0654H92.0352Z",
    fill: "#CBD3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.587 89.2012H110.641V90.7094H108.157V89.2012H106.211V96.2979H112.587V89.2012ZM110.641 92.864V94.1298H108.157V92.864H110.641Z",
    fill: "#CBD3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.532 101.456H116.6V96.8369H106.586V98.9242H114.654V99.3551H106.586V104.001H116.869V101.914H108.532V101.456Z",
    fill: "#CBD3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.603 89.2275H114.656V96.3108H116.603V93.7522H117.959V91.5168H116.603V89.2275Z",
    fill: "#CBD3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.083 97.2412H120.137V101.281H130.916V99.0457H122.083V97.2412Z",
    fill: "#CBD3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.969 89.2012V91.5174H126.969V93.7528H128.969V96.3383H130.915V89.2012H128.969Z",
    fill: "#CBD3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.739 96.446C120.739 96.446 122.954 94.0356 123.129 93.8605C123.29 94.0356 125.532 96.446 125.532 96.446L126.888 94.5069C126.888 94.5069 124.176 91.8002 123.813 91.4366H126.364V89.2012H119.867V91.4366H122.431C122.082 91.8002 119.41 94.48 119.41 94.48L120.739 96.4326V96.446Z",
    fill: "#CBD3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.739 96.446C140.739 96.446 142.954 94.0356 143.129 93.8605C143.29 94.0356 145.532 96.446 145.532 96.446L146.888 94.5069C146.888 94.5069 144.176 91.8002 143.813 91.4366H146.364V89.2012H139.867V91.4366H142.431C142.082 91.8002 139.41 94.48 139.41 94.48L140.739 96.4326V96.446Z",
    fill: "#CBD3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.443 89.3086H135.262V101.738H136.443V89.3086Z",
    fill: "#CBD3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.973 99.2738H142.403V101.765H143.879V99.2738H148.309V97.1865H137.973V99.2738Z",
    fill: "#CBD3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.021 89.3086H149.84V101.738H151.021V89.3086Z",
    fill: "#CBD3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.921 93.2279C57.921 92.393 57.6122 91.6658 56.9947 91.0464C56.3772 90.4269 55.6523 90.1172 54.82 90.1172C53.9206 90.1172 53.1688 90.4269 52.5513 91.0464C51.9338 91.6389 51.625 92.3661 51.625 93.2279C51.625 94.0897 51.9338 94.79 52.5513 95.4094C53.1688 96.0558 53.9206 96.379 54.82 96.379C55.6523 96.379 56.3772 96.0558 56.9947 95.4094C57.6122 94.79 57.921 94.0628 57.921 93.2279ZM55.6389 94.0763C55.3972 94.3187 55.1288 94.4533 54.8066 94.4533C54.4575 94.4533 54.1756 94.3321 53.934 94.0763C53.6923 93.8339 53.5715 93.5646 53.5715 93.2414C53.5715 92.9182 53.6923 92.6219 53.934 92.4065C54.1756 92.1641 54.4575 92.0429 54.8066 92.0429C55.1288 92.0429 55.4107 92.1641 55.6389 92.4065C55.8805 92.6489 56.0013 92.9182 56.0013 93.2414C56.0013 93.5646 55.8805 93.8473 55.6389 94.0763Z",
    fill: "#CBD3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6926 97.2275H51.7461V101.267H62.2305V99.032H53.6926V97.2275Z",
    fill: "#CBD3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8957 91.5041V89.2148H59.9492V96.325H61.8957V93.7395H63.2516V91.5041H61.8957Z",
    fill: "#CBD3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1096 89.2015H55.7067V87.626H53.7601V89.2015H51.3438V91.5447H58.123V89.2015H58.1096Z",
    fill: "#CBD3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.926 89.2148V91.5041H85.9258V93.7395H87.926V101.281H89.8725V89.2148H87.926Z",
    fill: "#CBD3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7233 89.2012L78.3672 95.9882L80.2063 97.2405L82.126 93.3757L84.0725 97.2405L85.9251 95.9882L82.569 89.2012H81.7233Z",
    fill: "#CBD3E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1652_3353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 152.232,
    height: 104,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmallTitle);
export default __webpack_public_path__ + "static/media/logoSmallTitle.7a274ec8ca2c71c379dd91807c5daa01.svg";
export { ForwardRef as ReactComponent };